import type { VehicleCategory } from '../types/case';

export const MEDIA = {
  car: 'https://cdn.magicpatterns.com/patterns/generated-images/88566566-2453-4cff-9172-436777421db6.jpg',
  motorcycle: 'https://cdn.magicpatterns.com/patterns/generated-images/238494a7-e84c-4e9d-880c-66515ea0f76a.jpg',
  truck: 'https://cdn.magicpatterns.com/patterns/generated-images/573d22ba-9a5a-496a-9a66-630a3e4aaad2.jpg',
  microbus: 'https://cdn.magicpatterns.com/patterns/generated-images/2e831a45-be83-492a-97f5-17c1f1bc55fc.jpg',
  cng: 'https://cdn.magicpatterns.com/patterns/generated-images/0cce0d0f-e1b8-4073-a91a-a7a1d769d443.jpg',
  bus: 'https://cdn.magicpatterns.com/patterns/generated-images/4fc61170-5da7-4ea6-ace7-6970d583103f.jpg',
  wrecker: 'https://cdn.magicpatterns.com/patterns/generated-images/ed16296b-d22a-430e-8895-853f79e5ab85.jpg',
  yard: 'https://cdn.magicpatterns.com/patterns/generated-images/0e9001d1-9134-4991-8ec7-1de99a98779b.jpg',
  pickup: 'https://cdn.magicpatterns.com/patterns/generated-images/718f3644-8840-4176-9ef7-07f9a9258e8c.jpg',
  police: 'https://cdn.magicpatterns.com/patterns/generated-images/e25563ef-2c70-4e8c-a12c-b0c4bab77e25.jpg',
};

export const CATEGORY_PHOTO: Record<VehicleCategory, string> = {
  car: MEDIA.car,
  motorcycle: MEDIA.motorcycle,
  truck: MEDIA.truck,
  microbus: MEDIA.microbus,
  cng: MEDIA.cng,
  bus: MEDIA.bus,
  pickup: MEDIA.pickup,
  other: MEDIA.car,
};
